/*tips: 在接收到子组件props方法改变的当前category的时候重新注册一次微信sdk(安卓的坑)*/

import * as React from 'react'
import CategorySwiper from '../Home/components/HomSwiper/HomeSwiper'
import * as CategoryStyles from './Category.style'
import CategoryMenuItem from './components/CategoryMenuItem/CategoryMenuItem'
import CategoryListItem from './components/CategoryListItem/CategoryListItem'
import CategoryRecommend from './components/CategoryRecommend/CategoryRecommend'
import {getJsonFromUrl, backToTop} from '../../utils/tools'
import CategoryType from '../Category/type/CategoryType'
import HomeType from '../Home/types/HomeType'
import Loading from '@/components/Loading/Loading'
import {HttpServer} from '@/services/server'
import CategoryRecommendPage from './components/CategoryRecommendPage/CategoryRecommendPage'
import { withRouter } from 'react-router-dom'
import globalBus from '@/services/Bus'

declare const Session: any

interface CategoryState {
    categoryData: {
        banner?: CategoryType.Banner[] | [],
        category?: CategoryType.Category | undefined,
        recommend?: {
            has_more: boolean,
            ret: HomeType.Content[]
        },
        starting?: {
            has_more: boolean,
            ret: HomeType.Content[]
        },
        shareInfo?: {
            content: string,
            share_url: string,
            title: string
        }
    },
    categoryMenu: CategoryType.Category | undefined,
    mode: string,
    isChangeType: boolean,
    categoryId: number,
}

@(withRouter as any)
export default class Category extends React.Component <any, CategoryState> {
    constructor(props: any) {
        super(props)
        globalBus.bindComponent(this, {
            categoryMenuData: (categoryMenuData) => {
                this.setState({
                    categoryMenu: categoryMenuData
                })
            },
            changeRecommendCategoryId: (changeRecommendCategoryId) => {
                this.setState({
                    mode: 'Recommend'
                })
            }
           }
        )
        this.state = {
            categoryMenu: {},
            categoryData: {},
            categoryId: 0,
            mode:  getJsonFromUrl().recommend === 'true' ? 'Recommend' : 'Normal',
            isChangeType: false
        }
    }

    public componentDidMount() {
        if (this.state.mode === 'Normal') {
            this.CategoryInfoInit()
        }
    }

    public initShare(info) {
        if (Session.weixinApi) {
            Session.weixinApi.initJSSDK()

            const shareData = {
                title: info.title,
                link: window.location.origin + window.location.pathname + window.location.search,
                desc: info.content,
                imgUrl: info.share_url
            }

            const timeShareData = {
                ...shareData,
                link: `https://share.lizhiweike.com${window.location.pathname}${window.location.search}`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])

        }
    }

    // 非推荐模块的数据请求
    public CategoryInfoInit() {
        const lastVisitCategory: string | null = window.sessionStorage.getItem('WKIndex/lastVisitCategory')
        const id = getJsonFromUrl().id
        if (id !== lastVisitCategory ) {
            window.scrollTo(0, 0)
            window.sessionStorage.setItem('WKIndex/lastVisitCategory', id)
        }
        HttpServer.getCategoryData(id).then((res) => {
            if (res.data.code === 0 ) {
                this.initShare(res.data.data.share_info)
                document.title = res.data.data.category.name
                globalBus.emit({categoryActiveId: res.data.data.category.sub_categories[0].parent_id})
                this.setState({
                    categoryMenu: res.data.data.category,
                    categoryData: res.data.data,
                    categoryId: res.data.data.category.sub_categories[0].id
                })
            }
        })
    }

    public changeCategory = (selectCid: number, type?: string) => {
        if (type === 'recommend') {
            this.props.history.replace(`?id=${selectCid}&recommend=true`)
            globalBus.emit({categorySelectId: 0})
            this.setState({
                mode: 'Recommend'
            })
            return
        }
        backToTop()
        this.setState({
            isChangeType: true,
            mode: 'Normal'
        })
        window.sessionStorage.setItem('WKIndex/lastVisitCategory', selectCid.toString())
        this.props.history.replace(`?id=${selectCid}`)
        HttpServer.getCategoryData(selectCid).then((res) => {
            if (res.data.code === 0 ) {
                document.title = res.data.data.category.name
                globalBus.emit({categorySelectId: selectCid})
                globalBus.emit({categoryActiveId: res.data.data.category.sub_categories[0].parent_id})
                this.initShare(res.data.data.share_info)
                this.setState({
                    categoryMenu: res.data.data.category,
                    categoryData: res.data.data,
                    categoryId: selectCid,
                    isChangeType: false
                })
            }
        })
    }

    public render() {
        return (
            <>
             {this.state.isChangeType &&  <Loading/>}
             <div className={CategoryStyles.selectMenu}>
                { Object.getOwnPropertyNames(this.state.categoryMenu).length > 0 &&
                    <CategoryMenuItem content={this.state.categoryMenu} changeCategoryId={this.changeCategory}/>
                }
            </div>
             {this.state.mode === 'Normal' ?
             <div>
                    <div className={CategoryStyles.CategorySwiper}>
                        {this.state.categoryData.banner &&
                            <CategorySwiper content={this.state.categoryData.banner}/>
                        }
                    </div>
                    {this.state.categoryData.starting &&
                        <CategoryListItem content={this.state.categoryData.starting} categoryId={this.state.categoryId}/>
                    }
                    {this.state.categoryData.recommend &&
                        <CategoryRecommend content={this.state.categoryData.recommend} categoryId={this.state.categoryId} isChangeType={this.state.isChangeType}/>
                    }
             </div> : <CategoryRecommendPage changeCategoryId={this.changeCategory}/>}
            </>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Category/Category.tsx